import React, { createContext, useState, useMemo } from "react";
import { api } from "../middlewares";

const ContextRenegociacao = createContext();

function Renegociacao({ children }) {
  const [simulacaoResult, setSimulacaoResult] = useState({});
  const [renegociacaoResult, setRenegociacaoResult] = useState({});
  const [
    showModalInformativoRenegociacao,
    setShowModalInformativoRenegociacao,
  ] = useState(false);
  const [
    modalInformativoRenegociacaoExibido,
    setModalInformativoRenegociacaoExibido,
  ] = useState(false);
  const simularRenegociacao = async (dadosSimulacao) => {
    let resultSimuladorRenegociacao = await api.get(
      "/Renegociacao/SimuladorRenegociacao",
      {
        params: { ...dadosSimulacao },
      }
    );

    setSimulacaoResult(resultSimuladorRenegociacao.data);
  };

  const getParcelasRenegociacao = async (idsVenda) => {
    let temp = await api.get("/Renegociacao/ParcelasAReceberRenegociacao", {
      params: {
        IdVenda: idsVenda?.IdVenda,
        IdVendaCarteira: idsVenda?.IdVendaCarteira,
      },
    });
    return temp;
  };

  const postRenegociacaoUAU = async (dadosRenegociacao) => {
    const { data } = await api.post("/Renegociacao/RenegociacaoUAU", {
      ...dadosRenegociacao,
    });

    setRenegociacaoResult(data);
    return data;
  };

  const postReenviarDocuSign = async (dadosReenvio) => {
    const resp = await api.post("/Renegociacao/ReenviarDocuSign", {
      ...dadosReenvio,
    });
    return resp.data;
  };

  const value = useMemo(
    () => ({
      simularRenegociacao,
      getParcelasRenegociacao,
      postRenegociacaoUAU,
      simulacaoResult,
      postReenviarDocuSign,
      renegociacaoResult,
      showModalInformativoRenegociacao,
      setShowModalInformativoRenegociacao,
      modalInformativoRenegociacaoExibido,
      setModalInformativoRenegociacaoExibido,
    }),
    [
      simulacaoResult,
      renegociacaoResult,
      showModalInformativoRenegociacao,
      modalInformativoRenegociacaoExibido,
    ]
  );

  return (
    <ContextRenegociacao.Provider value={value}>
      {children}
    </ContextRenegociacao.Provider>
  );
}

export { ContextRenegociacao, Renegociacao };
